import { Box } from "@mui/material"
import { ActivityUsers } from "./steps/activityUsers"
import { ActivityDetail } from "../shared/detail"
import { useLocation } from "react-router-dom"
import { Hashs } from "./utils"
import { CreateActivity } from "../shared/formActivity/create"
import { EditActivity } from "../shared/formActivity/edit"

export const ActivityRegister = () => {
    const location = useLocation()
    return (
        <Box>
            {location.hash.includes(Hashs.DETAIL) && (<ActivityDetail />)}
            {location.hash.includes(Hashs.CREATE) && (<CreateActivity goBack={{}} />)}
            {location.hash.includes(Hashs.EDIT) && (<EditActivity goBack={{}} />)}
            {!location.hash && <ActivityUsers />}
        </Box>
    )
}